import { Redirect } from 'expo-router'
import { useEffect } from 'react'
import Toast from 'react-native-toast-message'

const VerifyLoginScreen = () => {
	useEffect(() => {
		Toast.show({
			type: 'error',
			text1: 'This login link is no longer valid, please login again.',
		})
	}, [])

	return (
		<Redirect
			href={{
				pathname: '/login',
			}}
		/>
	)
}

export default VerifyLoginScreen
